import { HttpService } from '@/shared/lib/http'

export type TValidarSimulacaoParaPropostaResponse =
  | {
      result: true
    }
  | {
      result: false
      errors: Array<{
        code:
          | 'OVERDUE_INSTALLMENT'
          | 'SIMULATION_ALREADY_USED_BY_ANOTHER_PROPOSAL'
          | 'SIMULATION_ACCESSORY_ZEROED'
          | 'PRODUCT_UNAVAILABLE'
          | 'EXPIRED_SIMULATION'
        message: string
      }>
    }

export class ValidarSimulacaoParaProposta extends HttpService {
  execute = async (simulacaoId: string) => {
    return this.http.get<TValidarSimulacaoParaPropostaResponse>(
      `/api/v2/Simulacao/${simulacaoId}/disponivelParaProposta`,
    )
  }
}
